import { Action } from '@ngrx/store';
import { UserModel } from '../model/IUser';


export enum UserActionTypes {

    SetCurrentUser = '[User] Set LoggedIn user',
    LogOutUser = '[User] LogOutUser'

}

export class SetCurrentUser implements Action {

    readonly type = UserActionTypes.SetCurrentUser;
    constructor(public payload: UserModel) { }
}

export class LogOutUser implements Action {
    readonly type = UserActionTypes.LogOutUser;
}

export type UserAction = SetCurrentUser | LogOutUser;
